var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentUserId && _vm.currentUserMeta)?_c('router-link',{staticClass:"is-flex is-align-items-center",attrs:{"tag":"div","to":{
        path: `/`,
    }}},[_c('figure',{staticClass:"user_image image is-48x48 is-flex is-align-items-center",staticStyle:{"cursor":"pointer"},attrs:{"id":"userImage"}},[_c('img',{staticClass:"is-rounded",attrs:{"id":"userImageOpenModal","src":_vm.getPicture,"alt":"Profilbild"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }